function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("title", null, "VF_Iink_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M127.8 85H57c-15.7 0-28.4 12.7-28.5 28.4V163c0 15.7 12.7 28.4 28.4 28.4h70.8v28.4H57.1C25.7 219.7.3 194.3.3 163v-49.6c0-31.3 25.5-56.7 56.8-56.7h70.7V85zM156 85h70.8c15.7 0 28.4 12.7 28.5 28.4V163c0 15.7-12.7 28.4-28.4 28.4h-70.8v28.4h70.7c31.3-.1 56.7-25.5 56.8-56.8v-49.6c0-31.3-25.5-56.7-56.8-56.7H156V85z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85 123.3h113.4v28.3H85z"
})));